module.exports = __webpack_public_path__ + "img/odoo-crm-min21.90c48d86.png";